import { AloBase } from '@/models/alo/AloBase';
import { StateItem, buildStateItem } from '@/models/alo/StateItem';
import { AloStatutCompactGroup } from '@/models/alo/AloStatutCompactGroup';
import { AloFamille } from '@/models/alo/AloFamille';
import { AloRubrique } from '@/models/alo/AloRubrique';
import { AloUniver } from '@/models/alo/AloUniver';
import { ErrorMessage } from '@/models/alo/ErrorMessage';
import { ExportCatalogType } from '@/enum/ExportCatalogType';

export interface IUiState {   
    snackMessages:  Array<string>,
    errorMessages:  Array<ErrorMessage>,
    searchFlux:string
    sortFluxDesc:boolean
    sortFluxBy:string
    searchPartenaire:string
    sortPartenaireDesc:boolean
    sortPartenaireBy:string
    searchDataSource:string
    sortDataSourceDesc:boolean
    sortDataSourceBy:string	
    searchFeedDownload:string
    sortFeedDownloadDesc:boolean
    sortFeedDownloadBy:string
    searchFluxBuilder:string
    sortFluxBuilderDesc:boolean
    sortFluxBuilderBy:string	
    searchMeta:string
    sortMetaDesc:boolean
    sortMetaBy:string

    searchPersonne:string
    sortPersonneDesc:boolean
    sortPersonneBy:string

    searchProfilExclusion:string
    sortProfilExclusionDesc:boolean
    sortProfilExclusionBy:string

    searchGroupCarac:string
    sortGroupCaracDesc:boolean
    sortGroupCaracBy:string

    contentHeight:number

    filterGrouId:number
    filterDbName:string
    filterDbKey:string
    filterType:ExportCatalogType 
}

//Initial State
const state: IUiState = {   
    snackMessages: [],
    errorMessages: [],
    searchFlux:"",    
    sortFluxDesc:false,
    sortFluxBy:"",
    searchPartenaire:"",
    sortPartenaireDesc:false,
    sortPartenaireBy:"",
    searchDataSource:"",
    sortDataSourceDesc:false,
    sortDataSourceBy:"",
    searchFeedDownload:"",
    sortFeedDownloadDesc:false,
    sortFeedDownloadBy:"",
    searchFluxBuilder:"",
    sortFluxBuilderDesc:false,
    sortFluxBuilderBy:"",
    searchMeta:"",
    sortMetaDesc:false,
    sortMetaBy:"",

    searchPersonne:"",
    sortPersonneDesc:false,
    sortPersonneBy:"",
    
    searchProfilExclusion:"",
    sortProfilExclusionDesc:false,
    sortProfilExclusionBy:"",

    searchGroupCarac:"",
    sortGroupCaracDesc:false,
    sortGroupCaracBy:"",

    contentHeight:50,

    filterGrouId:0,
    filterDbName:'Tous',
    filterDbKey:'Tous',
    filterType:ExportCatalogType.OffersAndTree

}

export default state